import type { AppContext } from '../types';
import { getAccessToken } from '../auth/storage';

export class ApiError extends Error {
  constructor(message: string, readonly status: number, readonly code?: string) {
    super(message);
  }
}

/** Zentraler HTTP-Client mit JWT und serverseitig geprüftem Arbeitskontext. */
export async function apiRequest<T>(url: string, init: RequestInit = {}, context?: AppContext): Promise<T> {
  const headers = new Headers(init.headers);
  const token = getAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (context) {
    headers.set('X-Availora-Context-Type', context.type);
    headers.set('X-Availora-Context-Id', context.id);
  }
  if (init.body) headers.set('Content-Type', 'application/json');

  const response = await fetch(url, { ...init, headers });
  if (!response.ok) {
    const body = await response.json().catch(() => null) as { code?: string; message?: string | string[] } | null;
    const message = Array.isArray(body?.message) ? body.message.join(' ') : body?.message;
    throw new ApiError(message ?? `API error ${response.status}`, response.status, body?.code);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
